import axios from 'axios';

export function logFrontendActivity({
  group,
  subgroup,
  action,
  request_data,
  response_data,
  log_from = 'UI',
  log_ref = null,
  userid = null,
  orderid = null,
  tracking_number = null
}) {
  const ref = log_ref;
  console.log(ref)
  return axios.post(`${process.env.REACT_APP_API_DOMAIN}/api/activity-log`, {
    group,
    subgroup,
    action,
    request_data,
    response_data,
    log_from,
    log_ref: ref,
    userid: userid,
    orderid : orderid,
    tracking_number : tracking_number
  })
  .then(() => {
    return ref; // return the log_ref for chaining
  })
  .catch((err) => {
    console.error('Failed to log activity', err);
    return null;
  });
}
